export enum TaskEvents {
  'CREATE_TASK' = 'CREATE_TASK',
  'CREATED_TASK' = 'CREATED_TASK',
  'EDITED_TASK' = 'EDITED_TASK',
  'DELETED_TASK' = 'DELETED_TASK',
  'OPEN_EDIT_TASK_MODAL' = 'OPEN_EDIT_TASK_MODAL',
  'CLOSE_EDIT_TASK_MODAL' = 'CLOSE_EDIT_TASK_MODAL',
}
